module.exports = __webpack_public_path__ + "img/cup.be5030ca.webp";